import { SharedFeature } from '../features';

export const hasShadowDom = (prop: { [attribute: string]: string } | HTMLElement) => {
  if (prop instanceof HTMLElement) {
    return prop.getRootNode() instanceof ShadowRoot;
  }
  return !prop.disableFeatures?.includes(SharedFeature.ShadowDom);
};
